<template>
  <div class="fixed top-[72px] left-0 px-[20px] w-full" :class="type" @click="handleClick">
    <span
      class="bg-error relative pl-4 pr-[32px] font-inter text-sm py-[12px] w-full block rounded-[10px] text-white"
      :class="{ '!bg-[#20BF55]': type }"
    >
      {{ text }}
      <svg
        class="absolute top-[50%] translate-y-[-50%] right-4"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="5.38379"
          y="6.01025"
          width="2"
          height="15"
          rx="1"
          transform="rotate(-45 5.38379 6.01025)"
          fill="currentColor"
        />
        <rect
          x="15.9902"
          y="4.59619"
          width="2"
          height="15"
          rx="1"
          transform="rotate(45 15.9902 4.59619)"
          fill="currentColor"
        />
      </svg>
    </span>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  text: {
    type: String,
    required: true,
  },
  type: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['click']);

const handleClick = () => {
  emit('click');
};
</script>
